// import { Component, HostListener, OnInit } from '@angular/core';
import {
  Component,
  EventEmitter,
  HostListener,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { Observable, Subject, Subscription, forkJoin, interval } from "rxjs";
import { map, takeUntil } from "rxjs/operators";

import { EmitterService } from "src/app/EmitterService";
import { AppService } from "src/app/app.service";

@Component({
  selector: "app-modal",
  templateUrl: "./modal.component.html",
  styleUrls: ["./modal.component.scss"],
})
export class ModalComponent implements OnInit {
  modalShown: boolean;
  mainData: any;
  client_basis: any;
  sortedNotice: any;
  onl_button: any;
  Notices: any;
  AllmenuItems: any[];
  array1: any[];
  array2: any[];
  loadingData: boolean;
  subscription: any;
  modal: any;
  constructor(
    private appService: AppService,
    private emitterService: EmitterService
  ) {}

  ngOnInit() {
    // Check if the modal was shown in the current session
    this.modalShown = !!sessionStorage.getItem("modalShown");

    if (!this.modalShown) {
      // Show the modal here (you can use Bootstrap classes to control the modal display)
      // For example, you can add a class to your modal HTML like "show-modal" and use ngClass to toggle it
      // For now, I'll add the code to show the modal by default without any class toggling.
      this.showModal();
    }
    this.FetchMainData();
  }
  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  FetchMainData() {
    forkJoin([this.appService.getContents()]).subscribe(
      (response: any) => {
        console.log(response, "response FetchMainData");

        this.mainData = response[0].data;
        console.log(this.mainData, "Hello");
        if (this.mainData != null) {
          let modal_data = this.mainData.filter(
            (x) => x.ContentCategoryName =="modal"
          );
          this.modal = modal_data[0];
          console.log(this.modal, "All Modal Data");
        }
      },
      (error) => {
        // Handle errors
        console.error("Error:", error);
      }
    );
  }
  ngUnsubscribe(
    ngUnsubscribe: any
  ): import("rxjs").OperatorFunction<[any, any], [any, any]> {
    throw new Error("Method not implemented.");
  }
  sortByStartDate(data: any): any {
    throw new Error("Method not implemented.");
  }

  closeModal() {
    // Close the modal and set the flag in session storage
    this.modalShown = true;
    this.hideModal();
  }

  private showModal() {
    const myModal = document.getElementById("myModal");
    if (myModal) {
      myModal.style.display = "block";
      myModal.classList.add("show"); // Add the "show" class to display the modal
      const myTimeout = setTimeout(this.myGreeting, 6000);
    }
  }
  myGreeting() {
    const myModal = document.getElementById("myModal");
    if (myModal) {
      myModal.style.display = "none";
    }
  }

  private hideModal() {
    const myModal = document.getElementById("myModal");
    if (myModal) {
      myModal.style.display = "none";
    }
  }
}
